import { useState } from 'react';
import loadable from '@loadable/component';

import { Button, Text } from '@simplywallst/ui-core';
import PlusSolid from '@simplywallst/ui-core/icons/PlusSolid';

import { HideLgDown } from './styled';

const CreateWatchlistModal = loadable(() => import('../CreateWatchlistModal'));

export const CreateWatchlist = () => {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <Button
        styleType="passive"
        alignIcon="left"
        onClick={() => setShowModal(true)}
      >
        <PlusSolid fill="white" />
        <Text typography="inherit" textTransform="capitalize">
          <HideLgDown>New </HideLgDown>watchlist
        </Text>
      </Button>
      {showModal && (
        <CreateWatchlistModal
          onClose={() => setShowModal(false)}
          onCreate={() => setShowModal(false)}
        />
      )}
    </>
  );
};
